import { Component, Input, OnInit, Output, EventEmitter, SimpleChange } from '@angular/core';
import { PlaceBase } from 'src/app/common/models/place/place-base';
import { MessageDialogService } from '../../message-dialog/services/message-dialog.service';
import { PlaceAPIService } from 'src/app/services/API/place-api.service';
import { LoadingService } from 'src/app/services/UI/loading.service';
import { ResponseModel } from 'src/app/common/models/ResponseModel';
import { GuidGenerator } from 'src/app/common/helpers/guid-generator';
import { CustomError } from 'src/app/common/helpers/custom-error';
import { TranslateHandler } from 'src/app/common/helpers/translate-handler';
import { ComponentBase } from '../../base/component-base';
import { NotifierEvents } from 'src/app/common/enums/enums';
import { NotifierV2Service } from 'src/app/services/notifier-v2.service';

@Component({
  selector: 'app-place-editor-page-list',
  templateUrl: './place-editor-page-list.component.html',
  styleUrls: ['./place-editor-page-list.component.scss']
})

export class PlaceEditorPageListComponent extends ComponentBase implements OnInit {
  expectedUpdates = [NotifierEvents.RootMemberChanged];
  @Input() placeList: PlaceBase[] = [];
  @Input() timeStamp: any;
  @Output() onCompleted = new EventEmitter<PlaceBase>();

  private _selectedPlaceId: number;

  @Input()
  set selectedPlaceId(value: number) {
    if (this._selectedPlaceId !== value) {
      this._selectedPlaceId = value;
      this.editedPlaceId = value || null;
    }
  }

  get selectedPlaceId(): number {
    return this._selectedPlaceId;
  }
  
  searchPhrase: string = "";
  title: string;
  errorImg: string = "/assets/images/place-default.png";
  editedPlaceId: number | null = null;
  placeL: PlaceBase[] = []
  constructor(
    private messageDialogService: MessageDialogService,
    private placeApiService: PlaceAPIService,
    private loadingService: LoadingService,
    private translateHandler: TranslateHandler,
    notifierService: NotifierV2Service){
      super(notifierService);
    }


  ngOnInit(): void {    
      this.title = this.translateHandler.translate("lbl_place_list") ?? "",
      this.getPlaceList();
    }

  getTimeStampedImageUrl(url: string): string {
    return url ? `${url}&v=${this.timeStamp}` : this.errorImg;
  }

  onImageLoadingError(event: any): void {
    event.target.src = this.errorImg;
  }

  getPlaceList(): void {
    let processId = GuidGenerator.generate();
    this.loadingService.show(processId);
    this.placeApiService.getPlaceListWithCount(1, 1).subscribe({
      next: (response: ResponseModel<PlaceBase[]>) => {
        this.placeL = response.data;
      },
      error: (error) => {
        console.error('Error loading places:', error);
      },
      complete: () => {
        this.loadingService.hide(processId);
      }
    });
  }

  editPlace(place: PlaceBase): void {
    this.editedPlaceId = place.id;
    this.onCompleted.emit(place);
  }

get filteredPlaces(): PlaceBase[] {
  if (!this.searchPhrase || this.searchPhrase.trim() === '') {
    return this.placeL ?? [];
  }
  const phrase = this.searchPhrase.toLowerCase();
  return (this.placeL ?? []).filter(
    p => p.rawData?.toLowerCase().includes(phrase)
  );
}

deletePlace(place: PlaceBase): void {

  this.placeApiService.getReferenceToPlace(place.id).subscribe({
    next: (response: ResponseModel<number>) => {
      const message =
        this.translateHandler.translate("cnf_delete_place_confirmation_message", [place.rawData]) +
        this.translateHandler.translate("lnk_events", [response.data.toString()]);

      this.messageDialogService.openDeleteConfirmation(message).subscribe({
        next: (confirmed: boolean) => {
          if (!confirmed) {
            return; 
          }

          const processId = GuidGenerator.generate();
          this.loadingService.show(processId);

          this.placeApiService.deletePlace(place.id).subscribe({
            next: (deleteResponse: ResponseModel<boolean>) => {
              if (deleteResponse.data) {
                this.loadingService.hide(processId); 
                this.onCompleted.emit();
                this.getPlaceList();
              }
            },
            error: (err) => {
              console.error('Deletion failed:', err);
              this.loadingService.hide(processId); 
              throw new CustomError('PlacesEditorListNew => deletePlace() : ' + err, 911, false);
            }
          });
        },
        error: (err) => {
          console.error('Dialog error:', err);
        }
      });
    },
    error: (err) => {
      console.error('getReferenceToPlace failed:', err);
      throw new CustomError("PlaceComponent => getReferenceToPlace() : " + err, 911, false);
    }
  });
}

  notify(){
    this.title = this.translateHandler.translate("lbl_place_list") ?? "",
    this.getPlaceList();
  }

}
